import _                              from 'underscore';
import React, { useEffect, useState } from 'react';
import { Checkbox, List }             from 'semantic-ui-react';

import { runIfFunction }                from '@src/util';
import { CorvalBusinessFunction, Uuid } from '@src/types';


interface CompareProjectBusinessFunctionsToolOptionsProps<T = never> {
    initialValue?: CorvalBusinessFunction[],
    onChange: ( data: CompareProjectBusinessFunctionsToolOptionsData ) => void,
    termDictionary?: null,
}

interface CompareProjectBusinessFunctionsToolOptionsData<T = never> {
    businessFunctions: [];
}

const businessFunctionSet = [] as CorvalBusinessFunction[];

const compareProjectBusinessFunctionsToolDefaultOptions = businessFunctionSet;

function CompareProjectBusinessFunctionsToolOptions<T>(
    {
        initialValue = compareProjectBusinessFunctionsToolDefaultOptions,
        termDictionary,
        onChange = null,
    }: CompareProjectBusinessFunctionsToolOptionsProps<T> ){

    const [ selectedBusinessFunctions, setSelectedBusinessFunctions ] = useState<Uuid[]>( initialValue );

    useEffect( () => {

        runIfFunction( onChange, selectedBusinessFunctions );

    }, [ selectedBusinessFunctions ] );

    const handleOnChanged = ( e, data ) => {

        const checked = data.checked;
        const value = data.value;

        setSelectedBusinessFunctions( prevState => {

            return ( checked )
                   ? [ ...prevState, value ]
                   : _.without<Uuid[]>( prevState, value );
        } );

    };

    return (
        <>
            <h5>Business Functions</h5>

            <List relaxed divided>
                { businessFunctionSet.map( ( value ) => {

                    const label = value.name;

                    return (
                        <List.Item key={ value.id }>

                            <Checkbox
                                label={ label }
                                value={ value.id }
                                defaultChecked={ selectedBusinessFunctions.includes( value ) }
                                onChange={ handleOnChanged }/>

                        </List.Item>
                    );

                } ) }
            </List>
        </>
    );
}

export {
    CompareProjectBusinessFunctionsToolOptions,
    compareProjectBusinessFunctionsToolDefaultOptions,
};
